import { Link } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export default function TermosDeUso() {
  return (
    <div className="min-h-screen bg-muted/30 px-4 py-10">
      <div className="mx-auto max-w-3xl space-y-6">
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">WeAuto</p>
          <h1 className="text-3xl font-bold">Termos de Uso</h1>
          <p className="text-sm text-muted-foreground">
            Última atualização: 2 de maio de 2026.
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Uso da plataforma</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-muted-foreground">
            <p>
              O WeAuto é uma plataforma para gestão de veículos, avaliações e fechamentos comerciais.
              O uso da conta é de responsabilidade da loja cadastrada e de seus usuários autorizados.
            </p>
            <p>
              Você se compromete a fornecer informações verdadeiras, proteger as credenciais de acesso
              e não utilizar a plataforma para fins ilícitos ou que violem direitos de terceiros.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Planos, cobrança e cancelamento</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-muted-foreground">
            <p>
              O acesso pode incluir período de teste, plano pago recorrente ou ambos, conforme oferta
              vigente no momento da contratação.
            </p>
            <p>
              O cancelamento pode ser solicitado a qualquer momento. Após o cancelamento, a assinatura
              permanece válida até o fim do ciclo já pago, quando aplicável.
            </p>
            <p>
              Em caso de inadimplência, a conta poderá ter acesso limitado até a regularização do
              pagamento.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Suporte e disponibilidade</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-muted-foreground">
            <p>
              O suporte é prestado pelos canais informados pela WeAuto. Podemos realizar manutenções,
              correções e atualizações para manter a operação da plataforma.
            </p>
            <p>
              Embora adotemos medidas razoáveis de segurança e disponibilidade, não garantimos operação
              ininterrupta ou livre de falhas.
            </p>
          </CardContent>
        </Card>

        <p className="text-sm text-muted-foreground">
          Ao criar sua conta, você declara que leu e concorda com estes termos.
        </p>

        <Link to="/cadastro" className="text-sm font-medium text-primary hover:underline">
          Voltar para o cadastro
        </Link>
      </div>
    </div>
  )
}
